import { LoadingButton } from "@mui/lab";
import { Box, Divider, Icon, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FolderDto, ProjectService } from "../../api/psc";

import {
    DialogContainer,
    DialogHeader,
    EmptyListMessage,
} from "../../components/exports";
import { DialogContext } from "../../contexts/DialogContext";
import { setProjectDetailFolders } from "../../slices/ProjectDetailSlice";
import { RootState } from "../../slices/Store";
import UpsertFolder from "../folders/dialogs/UpsertFolder";
import SelectFolderItem from "./Shared/SelectFolderItem";

// updated
export default function SelectFolderDialog() {
    const dispatch = useDispatch();

    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const sharedState = useSelector((state: RootState) => state.shared);

    const projectFolderIds = projectDetailState.projectDetail.folders.map(
        (f) => f.id
    );

    const [selectedFolderIds, setSelectedFolderIds] =
        useState<number[]>(projectFolderIds);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const { openDialog, closeDialog } = useContext(DialogContext);

    const toggleFolderInProject = (folder: FolderDto) => {
        const updatedFolderIds = [...selectedFolderIds];

        if (selectedFolderIds.includes(folder.id)) {
            const index = selectedFolderIds.indexOf(folder.id);
            updatedFolderIds.splice(index, 1);
        } else {
            updatedFolderIds.push(folder.id);
        }

        setSelectedFolderIds(updatedFolderIds);
    };

    const openCreateNewFolderDialog = () => {
        openDialog(<UpsertFolder />);
    };

    const applyUpdatedFolder = () => {
        setRequestInProgress(true);
        ProjectService.batchUpdateProjectFolders("1", {
            projectHashIds: [projectDetailState.projectHashId],
            folderIds: selectedFolderIds,
        })
            .then((r) => {
                const folders = sharedState.folders.filter((f) =>
                    selectedFolderIds.includes(f.id)
                );
                dispatch(setProjectDetailFolders(folders));
            })
            .finally(() => {
                setRequestInProgress(false);
                closeDialog();
            });
    };

    const foldersHaveChanged =
        selectedFolderIds.find((id) => !projectFolderIds.includes(id)) ||
        projectFolderIds.find((id) => !selectedFolderIds.includes(id));

    return (
        <DialogContainer>
            <DialogHeader title="انتخاب پوشه" />

            <Box sx={{ p: 2 }}>
                <EmptyListMessage
                    message="پوشه ای یافت نشد"
                    condition={sharedState.folders.length === 0}
                    disablePadding
                />

                {sharedState.folders.map((f, i) => {
                    return (
                        <Box key={f.id}>
                            <SelectFolderItem
                                folder={f}
                                checked={selectedFolderIds.includes(f.id)}
                                onToggle={toggleFolderInProject}
                            />
                            {i !== sharedState.folders.length - 1 && (
                                <Divider sx={{ my: 1 }} />
                            )}
                        </Box>
                    );
                })}

                <Divider sx={{ my: 2 }} />

                <Box
                    sx={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                    onClick={openCreateNewFolderDialog}
                >
                    <Icon color="primary">add</Icon>
                    <Typography color="primary" sx={{ flexGrow: 1 }}>
                        افزودن پوشه جدید
                    </Typography>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <LoadingButton
                        fullWidth
                        disabled={!foldersHaveChanged}
                        loading={requestInProgress}
                        variant="contained"
                        onClick={applyUpdatedFolder}
                    >
                        ذخیره تغییرات
                    </LoadingButton>
                </Box>
            </Box>
        </DialogContainer>
    );
}
